import * as React from 'react';
import { View, StyleProp, ViewStyle } from 'react-native';
import Svg, { Path } from 'react-native-svg';

const AnalyticsSvg = React.memo(
    (props: {
        size?: number;
        primaryColor?: string;
        containerStyle?: StyleProp<ViewStyle>;
    }) => {
        // Calculate dimensions based on the original SVG's aspect ratio
        // Original SVG dimensions: 18x19
        const size = props.size ?? 18;
        const width = size * (18 / 19);
        const height = size;

        return (
            <View style={props.containerStyle}>
                <Svg
                    width={width}
                    height={height}
                    viewBox="0 0 18 19"
                    fill="none"
                    {...props}
                >
                    <Path
                        d="M0 9.73291C0 10.2852 0.447715 10.7329 1 10.7329H7C7.55228 10.7329 8 10.2852 8 9.73291V1.73291C8 1.18063 7.55228 0.73291 7 0.73291H1C0.447715 0.73291 0 1.18063 0 1.73291V9.73291ZM0 17.7329C0 18.2852 0.447715 18.7329 1 18.7329H7C7.55228 18.7329 8 18.2852 8 17.7329V13.7329C8 13.1806 7.55228 12.7329 7 12.7329H1C0.447715 12.7329 0 13.1806 0 13.7329V17.7329ZM10 17.7329C10 18.2852 10.4477 18.7329 11 18.7329H17C17.5523 18.7329 18 18.2852 18 17.7329V9.73291C18 9.18063 17.5523 8.73291 17 8.73291H11C10.4477 8.73291 10 9.18062 10 9.73291V17.7329ZM11 0.73291C10.4477 0.73291 10 1.18063 10 1.73291V5.73291C10 6.28519 10.4477 6.73291 11 6.73291H17C17.5523 6.73291 18 6.28519 18 5.73291V1.73291C18 1.18063 17.5523 0.73291 17 0.73291H11Z"
                        fill={props.primaryColor ?? '#F35E2E'}
                    />
                </Svg>
            </View>
        );
    },
);

AnalyticsSvg.displayName = 'AnalyticsSvg';

export { AnalyticsSvg };
